export interface RubricaInfo {
    icon: string;
    description: string;
    range: any;
}

export interface RubricGrade {
    subCompetenceId: string;
    evaluationNote: number | string;
}